import i18n from '../plugins/i18n';

export const required = v => !!v || i18n.t('messages.required');

export const mobile = v => v && /^[\\+]?[(]?[0-9]{3}[)]?[-\s\\.]?[0-9]{3}[-\s\\.]?[0-9]{5,6}$/.test(v) || i18n.t('messages.mobile_validation_error');

export const password = v => v && v.length >= 6 || i18n.t('messages.password_validation_error');

export const to = v => v && /^[\\+]?[(]?[0-9]{3}[)]?[-\s\\.]?[0-9]{3}[-\s\\.]?[0-9]{5,6}$/.test(v) || i18n.t('messages.to_validation_error');

export const maxUploadSize = file => file && file.size <= 5e+6 || i18n.t('messages.upload_size_validation_error', { mb_max_size : 5});

export const acceptableDocumentFormat = file => file && file.type === 'application/pdf' || i18n.t('messages.only_pdf_acceptable');




